import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { Slider } from 'core/components/ui'
import { font } from 'assets/themes/theme-default'
import FilterTitle from '../title'

const CustomSlider = styled(Slider)`
  .ant-slider-mark-text {
    font-size: ${font.size.sm};
  }
`

const SliderWrapper = styled.div`
  padding: 0 20px 5px;
`

const CV = props => {
  const [currentValues, setCurrentValues] = useState([])

  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { taxHorsepowerMin, taxHorsepowerMax } = filters
  const cvsList = filtersDatas.taxHorsepowers

  const formatter = value => {
    const intlValue = intl.formatNumber(value)

    return `${intlValue} CV`
  }

  const marks = {}

  const maxValue = currentValues[1]
  const minValue = currentValues[0]

  marks[maxValue] = formatter(maxValue)
  marks[minValue] = formatter(minValue)

  const onChange = value => {
    setCurrentValues(value)
  }

  const handleOnChangeFiltre = item => {
    const [min, max] = item

    const extendedFiltersValues = {
      ...filters,
      taxHorsepowerMin: min,
      taxHorsepowerMax: max
    }

    onChangeFilter(extendedFiltersValues)
  }

  useEffect(() => {
    const values = []
    if (cvsList) {
      const maxVal = taxHorsepowerMax || cvsList.max
      const minVal = taxHorsepowerMin || cvsList.min

      values[0] = minVal
      values[1] = maxVal
    }
    setCurrentValues(values)
  }, [])

  return (
    <div data-test="component-stock-vehicles-list-filters-cv">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-CV-title'
        })}
        data-test="stock-vehicles-list-filters-cv-title"
      />
      <SliderWrapper>
        {cvsList && (
          <CustomSlider
            defaultValue={currentValues}
            max={cvsList.max}
            min={cvsList.min}
            step={cvsList.step}
            range
            marks={marks}
            onAfterChange={value => handleOnChangeFiltre(value)}
            onChange={value => onChange(value)}
            tooltipVisible={false}
            data-test="stock-vehicles-list-filters-cv-slider"
          />
        )}
      </SliderWrapper>
    </div>
  )
}

CV.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(CV)
